/* eslint-disable no-empty-pattern */
import React, { useContext } from 'react'
import { StateContext } from '../../Util/StateContext/StateContext';
import { useTable } from 'react-table'
import Emoji from '../Emoji/Emoji'
import QuantityCellState from '../QuantityCell/QuantityCellState';
import white_filter_svg from '../../assets/white-icon-filter.svg';
import blue_filter_svg from '../../assets/blue-icon-filter.svg';




//**RENDERED TABLE COMPONENT */
function Table({ columns, data, isFetching, isLoading, showFilters, setShowFilters }) {
  const { state, dispatch } = useContext(StateContext);

  //Toggle Support
  const ToggleOrder = (orderby, order) => {
    //TODO: Prevent double fetch - update reducer to set orderby & set order at the same time
    dispatch({ type: "SET_ORDERBY", payload: orderby });
    dispatch({ type: "SET_ORDER", payload: order });
  };
  const ToggleOrderBy = (order) => {
    switch (order) {
      case "ASC":
        return "DESC";
      case "DESC":
        return "";
      default:
        return "ASC";
    }
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows
  } = useTable({
    columns,
    data
  });
  // is-visible
  return (
    <div id="catalog-table">
      <div className={isFetching ? "table-wrapper" : "table-wrapper"}>
        <div className="thead-bar">
          <button
            id="filter-toggle"
            className={showFilters ? "is-open" : ""}
            onClick={() => setShowFilters(!showFilters)}
            aria-label={"Toggle Filter Drawer"}
          >
            {!showFilters ? <img alt="Arrow toggle for filter" src={white_filter_svg} /> : <img alt="Arrow toggle for filter" src={blue_filter_svg} /> }
            
            <p>{showFilters ? "Close" : "Filters/Search"}</p>
          </button>
        </div>
        <table {...getTableProps({})}>
          <thead>
            {headerGroups.map(headerGroup => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th onClick=
                    {
                      () => {
                        if (column.id !== 'qty') {
                          ToggleOrder(column.id, ToggleOrderBy(state.order));
                        }
                      }
                    }
                    {...column.getHeaderProps({
                      style: {
                        minWidth: column.minWidth,
                        maxWidth: column.maxWidht,
                        width: column.width,
                        textAlign: column.textAlign
                      }
                    })}>{column.render('Header')}
                    {state.orderby === column.id
                      ? state.order === ""
                        ? ""
                        : state.order === "ASC"
                          ? <Emoji symbol="⬆️" label="Up Arrow" />
                          : <Emoji symbol="⬇️" label="Down Arrow" />
                      : ""
                    }
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <div className="scroll-wrapper">


            {(data.length === 0) ?
              <tbody>
                <div className="center">
                  <p>No parts found</p>
                </div>
              </tbody> :
              <tbody {...getTableBodyProps()}>
                {rows.map((row, i) => {
                  prepareRow(row)
                  return (
                    <tr {...row.getRowProps()}>
                      {
                        row.cells.map(cell => {
                          let style = {
                            height: 50
                          }
                          if (cell.column.id === "qty") {
                            return (
                              <td key={cell.row.original.id} style={style} className={isFetching || isLoading ? '--is-fetching quantity-cell' : 'quantity-cell'} {...cell.getCellProps()}>
                                <QuantityCellState
                                  cell={cell}
                                  showTrash={false}
                                  showAddtoRequest={true}
                                >
                                </QuantityCellState>
                              </td>
                            )
                          } else {
                            return (
                              <td key={cell.row.original.id} style={style} className={isFetching || isLoading ? '--is-fetching' : ''} {...cell.getCellProps()}>
                                {
                                  (cell.column.id === "root_part_numbers") ? <a rel="noreferrer" href={cell.row.original.link}>{cell.render('Cell')}</a> : cell.render('Cell')
                                }
                              </td>
                            )
                          }
                        })}
                    </tr>
                  )
                })}
              </tbody>
            }



            {!rows &&
              <p style={{
                margin: "1rem auto",
                display: "block",
                textAlign: "center"
              }}>Sorry! There were no products found.</p>
            }
          </div>
        </table>
      </div>
    </div>

  )

}

export default Table;